<template>
  <div class="dailyReport">
    <crumbs>
      <i class="icon-copy"></i>
      <span class="text">{{multiLanguage.crumbs.dailyReport}}</span>
    </crumbs>
    <div class="content">
      <div class="panel">
        <div v-if="path.length > 0" class="btn btn-default getBack" @click="goPath(-1)">{{multiLanguage.getBack}}</div>
        <mtable ref="mtable"
          :thData="thData"
          :trData="trData"
          :totalData="trData"
          :multiLanguage="multiLanguage"
          :seekDropdown="seekDropdown"
          :seekDatePicker="seekDatePicker"
          :sort="sort"
          :jsonExcelAjax="jsonExcelAjax"
          @tableChange="tableAjax">
          <div slot="datatable-scroll" class="nodePath">
              <div id="chooseCheck">
                <div class="checker" v-for="(item,index) in checkboxs">
                  <span  :class="{ 'checked' : item.bool}">
                    <input class="choosebox" type="checkbox" @click="toggle(item)" :value="item.name" :id="item.name" v-model="allType">
                  </span>
                  <label class="labelStyle" :for="item.name">
                      {{multiLanguage.th.loginType.typeArr[index].text}}
                  </label>
                </div>
              </div>
            <div class="m-6">
              <span class="span">开户总数&nbsp;:&nbsp;{{apply.counts}}</span>
              <span class="span">开户成功&nbsp;:&nbsp;{{apply.approved}}</span>
              <span class="span">开户失败&nbsp;:&nbsp;{{apply.fail}}</span>
              <span class="span">等待审核&nbsp;:&nbsp;{{apply.tracking}}</span>
            </div>
            {{multiLanguage.tier}}&nbsp;:&nbsp;<span v-for="(item,index) in path" @click="goPath(item)" v-if="path.length > 0"><span v-if="index">/</span><span class="path-item" v-if="item">{{item}}</span></span>
          </div>
        </mtable>
      </div>
    </div>
  </div>
</template>

<script>
  import { POSITIONS_SEARCH } from "api/api.js"
  import crumbs from "components/crumbs"
  import mtable from "components/mtable"

// @clickCol="clickCol"
// :trCls="(item) => { return getaccType(item.acc_type) != 'CL' ? 'pointer' : '' }"
  export default {
    name: "loginSalePlatform",
    mixins: [
      require("common/mixin/base.js").base({multiLanguage: "tableModel"})
    ],
    data () {
      return {
        allType: [],
        checkboxs: [
          {
            name: "UN",
            bool: false
          },
          {
            name: "C",
            bool: false
          },
          {
            name: "N",
            bool: false
          },
          {
            name: "R",
            bool: false
          },
          {
            name: "O",
            bool: false
          },
          {
            name: "M",
            bool: false
          },
          {
            name: "SL",
            bool: false
          },
          {
            name: "IB",
            bool: false
          },
          {
            name: "CL",
            bool: false
          }
        ],
        trData: [],
        sort: {  // 排序
          key: "node_id",
          method: "ASC"
        },
        seekDropdown: {  // 搜索选项
          list: {
            loginId: "node_id"
          },
          active: "loginId",
          seekStr: ""
        },
        seekDatePicker: {
          startDate: this.$moment().subtract(1, "days").format("YYYY-MM-DD"),
          endDate: this.$moment().format("YYYY-MM-DD")
        },
        jsonExcelAjax: {},
        usersType: [],
        path: [],
        apply: false
      }
    },
    mounted () {
    },
    computed: {
      thData () {  // 表格th数据
        return [this.multiLanguage.th.loginId, this.multiLanguage.th.accountName, this.multiLanguage.th.loginType.name, this.multiLanguage.th.mt4_sync_deposits_sum, this.multiLanguage.th.mt4_sync_withdrawal_sum, this.multiLanguage.th.balance2, this.multiLanguage.th.balance, this.multiLanguage.th.volume_sum, this.multiLanguage.th.newAgentCount, this.multiLanguage.th.newClientCount]
      }
    },
    methods: {
      toggle (item) {
        item.bool = !item.bool
      },
      clickCol (colItem, index) {
        if (this.usersType[index] !== "CL") {
          this.path.indexOf(colItem.sales_id) == -1 && this.path.push(colItem.sales_id)
          this.tableAjax(this.path[this.path.length - 1])
        }
      },
      goPath (path) {
        let index = path != -1 ? this.path.indexOf(path) + 1 : -1
        this.path = this.path.slice(0, index)
        this.tableAjax(this.path[this.path.length - 1])
      },
      tableAjax (node_id = "", searchKeys = "", nodeIdType = []) {
        let startDate = this.seekDatePicker.startDate + " 00:00:00"
        let endDate = this.seekDatePicker.endDate + " 23:59:59"
        searchKeys = this.seekDropdown.seekStr

        nodeIdType = this.allType
        this.$http.post(POSITIONS_SEARCH, {nodeIdType, node_id, searchKeys, startDate, endDate}).then((res) => {
          let data = res.data.data
          if (res.data.code === 200) {
            this.apply = res.data.data.apply
            let dataList = []
            this.usersType = []
            data.sales = data.sales ? data.sales : []
            data.sales.forEach(item => {
              this.usersType.push(item.acc_type)
              dataList.push({
                sales_id: this.defaultVal(item.node_id),
                acc_name: this.defaultVal(item.name),
                acc_type: this.defaultVal(this.setaccType(item.acc_type)),
                mt4_sync_deposits_sum: this.defaultVal(item.mt4_sync_deposits_sum),
                mt4_sync_withdrawals_sum: this.defaultVal(item.mt4_sync_withdrawals_sum),
                margin: this.defaultVal((item.mt4_sync_deposits_sum || 0) + (item.mt4_sync_withdrawals_sum || 0)),
                balance: this.defaultVal(item.balance),
                volume_sum: this.defaultVal(item.volume_sum),
                newAgentCount: this.defaultVal(item.agentcount),
                newClientCount: this.defaultVal(item.clientcount)
              })
            })
            this.trData = dataList
          } else {
            this.trData = []
          }
        })
      },
      defaultVal (val) {
        if ((val || val == 0) && Object.prototype.toString.call(val) === "[object Number]") {
          return (/\./).test(val) ? parseFloat(val.toFixed(2)) : val
        } else if (val || val == 0) {
          return val
        } else {
          return 0
        }
      },
      setaccType (acc_type) {
        switch (acc_type) {
          case "UN":
            return this.multiLanguage.th.loginType.typeArr[0].text
          case "C":
            return this.multiLanguage.th.loginType.typeArr[1].text
          case "N":
            return this.multiLanguage.th.loginType.typeArr[2].text
          case "R":
            return this.multiLanguage.th.loginType.typeArr[3].text
          case "O":
            return this.multiLanguage.th.loginType.typeArr[4].text
          case "M":
            return this.multiLanguage.th.loginType.typeArr[5].text
          case "SL":
            return this.multiLanguage.th.loginType.typeArr[6].text
          case "IB":
            return this.multiLanguage.th.loginType.typeArr[7].text
          case "CL":
            return this.multiLanguage.th.loginType.typeArr[8].text
          default:
            return acc_type
        }
      },
      getaccType (acc_type) {
        switch (acc_type) {
          case this.multiLanguage.th.loginType.typeArr[0].text:
            return "UN"
          case this.multiLanguage.th.loginType.typeArr[1].text:
            return "C"
          case this.multiLanguage.th.loginType.typeArr[2].text:
            return "N"
          case this.multiLanguage.th.loginType.typeArr[3].text:
            return "R"
          case this.multiLanguage.th.loginType.typeArr[4].text:
            return "O"
          case this.multiLanguage.th.loginType.typeArr[5].text:
            return "M"
          case this.multiLanguage.th.loginType.typeArr[6].text:
            return "SL"
          case this.multiLanguage.th.loginType.typeArr[7].text:
            return "IB"
          case this.multiLanguage.th.loginType.typeArr[8].text:
            return "CL"
          default:
            return acc_type
        }
      }
    },
    watch: {
      trData (curVal, oldVal) {
        this.jsonExcelAjax.colData = curVal
      }
    },
    components: {
      mtable,
      crumbs
    }
  }
</script>

<style lang="scss" type="text/scss">
.dailyReport{
  .panel{
    position: relative;
    .seekDatePicker{
      margin: 0;
      .btn-primary{
        display: none;
      }
    }
   #chooseCheck{
    height: 40px;
      .checker{
    cursor:default;
    width:80px;
      span{
        height:100%;
      }
      .labelStyle{
        margin-left: 5px;
        position:absolute;
        line-height: 20px;
        height:20px;
         display:inline-block;
         width:50px;
         cursor:pointer;
       }
    }
   }
    .seek{
      .btn-default{
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
        border-left: 0;
      }
    }
    .getBack{
      position: absolute;
      top: 20px;
      right: 20px;
      z-index: 10
    }
    .m-6{
      margin-bottom: 6px;
      .span{
        margin-right: 10px;
      }
    }
    .nodePath{
      position: relative;
      top: -7px;
      padding: 0 22px;
      .path-item{
        transition: all 0.23s;
      }
      .path-item:hover{
        color: #26b19A;
        cursor: pointer;
      }
    }
  }
  tbody{
    // tr{
    //   cursor: pointer;
    // }
    // tr:nth-child(1){
    //   cursor: auto;
    // }
    border-bottom: 1px solid #bbb;
  }
}

</style>



// WEBPACK FOOTER //
// dailyReport.vue?50ac8b68